import { ListSubheader, TextField } from '@material-ui/core'
import Autocomplete, { AutocompleteRenderGroupParams } from '@material-ui/lab/Autocomplete'
import match from 'autosuggest-highlight/match'
import parse from 'autosuggest-highlight/parse'
import { uniqueId } from 'lodash'
import { ChangeEvent } from 'react'

import { orgSubActivities } from '@percent/admin-dashboard/constants/organisationActivities'
import { ActivityCheckSearchDropdownProps, ActivityCheckUpdatedCode } from './ActivityCheckDetail.types'
import styles from './ActivityCheckSearchDropdown.module.scss'

const renderGroup = (params: AutocompleteRenderGroupParams) => [
  <ListSubheader className={styles.renderGroup} key={params.key}>
    {params.group}
  </ListSubheader>,
  params.children
]

export function ActivityCheckSearchDropdown({ updatedCode, setUpdatedCode }: ActivityCheckSearchDropdownProps) {
  const options = Object.keys(orgSubActivities)
    .map((key: string) => {
      const orgSubActivity = orgSubActivities[key as keyof typeof orgSubActivities]

      return {
        primaryDescription: `${orgSubActivity.primaryActivityCode} - ${orgSubActivity.primaryActivityDescription}`,
        subDescription: `${orgSubActivity.subActivityCode} - ${orgSubActivity.subActivityDescription}`,
        definition: orgSubActivity.definition
      }
    })
    .sort((a, b) => a.primaryDescription.localeCompare(b.primaryDescription))

  const handleAutocompleteChange = (_: ChangeEvent<{}>, newValue: ActivityCheckUpdatedCode | null) => {
    if (!newValue) return
    setUpdatedCode(newValue)
  }

  return (
    <Autocomplete
      value={updatedCode}
      onChange={handleAutocompleteChange}
      options={options}
      groupBy={option => option.primaryDescription}
      getOptionLabel={option => option.subDescription}
      className={styles.autocomplete}
      renderInput={params => (
        <TextField
          {...params}
          label={updatedCode.primaryDescription}
          variant="outlined"
          className={styles.autoCompleteFieldSet}
        />
      )}
      renderGroup={renderGroup}
      getOptionSelected={(option, val) =>
        option.subDescription === val.subDescription && option.primaryDescription === val.primaryDescription
      }
      renderOption={(option, { inputValue }) => {
        const matches = match(option.subDescription, inputValue)
        const parts = parse(option.subDescription, matches)

        const activityTagName = parts.map(part => (
          <div key={uniqueId()} className={styles.dropdownOptionWrapper}>
            <span className={part.highlight ? styles.dropdownOptionHighlighted : styles.dropdownOption}>
              {part.text}
            </span>
          </div>
        ))

        return (
          <div className={styles.dropdownContainer}>
            <div>{activityTagName}</div>
            <div className={styles.definition}>{option.definition}</div>
          </div>
        )
      }}
    />
  )
}
